import { createAsyncAction } from 'typesafe-actions';
import { FhqUsers } from '@rootCommon/types/fhq';
import { IdType } from '@rootCommon/types/common';

export const fetchFhqUsers = createAsyncAction(
  'FETCH_FHQ_USERS_REQUEST',
  'FETCH_FHQ_USERS_SUCCESS',
  'FETCH_FHQ_USERS_FAILURE',
)
<IdType[], FhqUsers[], Error>();

export const updateFhqUsers = createAsyncAction(
  'UPDATE_FHQ_USERS_REQUEST',
  'UPDATE_FHQ_USERS_SUCCESS',
  'UPDATE_FHQ_USERS_FAILURE',
)
<FhqUsers[], void, Error>();
